import { localization } from '../../../locales';
export const getLanguage = (initLang, application) => {
    if (initLang && Object.keys(localization).includes(initLang))
        return initLang;
    return application === 'Happydesk' ? 'ru' : 'en';
};
